import { useRouteLoaderData } from 'react-router-dom';

export const useRouteLoaderDataTyped = <T extends unknown>(routeId: string) => (
    useRouteLoaderData(routeId) as T
);

export default useRouteLoaderDataTyped;
